<div class="login-main-wrapper">
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="">
      <app-left-layout></app-left-layout>
    </div>
    <div
      class="login-right-side position-relative flex-fill d-flex flex-column justify-content-center align-items-center vh-100 overflow-lg-auto">
      <img src="assets/images/icons/close-circle.png" (click)="logoutModal()" alt="" class="logout-icon">
      <div class="right-content">
        <!-- <app-google-translate></app-google-translate> -->
        @if (selectedStep === step.MOBILE_NUMBER) {
          <form [formGroup]="verifyForm" action="" (submit)="verifyPhoneNumber()">
            <div>
              <div class="mb-4">
                <h2 class="fs-36 fw-600 m-0 mb-3">
                  Verify Your Phone <br> Number
                </h2>
                <p class="fs-16 fw-400 text-secondary m-0">
                  Enter your phone number below to receive a 6-digit verification code
                </p>
              </div>
              <div class=" form-group mt-4 mb-3">
                <!-- <p class="fs-14 fw-500 text-secondary m-0">
                Enter Your Phone number
              </p> -->
              <div class="d-flex flex-column-reverse custom-form inputContainer position-relative">
                <p class="position-absolute" style="left: 15px;top: 43px;">
                {{country_data && country_data.mobile_code ? country_data.mobile_code : '+1'}}</p>
                <input style="padding-left: 45px;" type="text" [mask]="mask" name="doctor_mobile" required=""
                  name="doctor_mobile" formControlName="doctor_mobile"
                  placeholder="Enter Phone Number" class="input_field ">
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3 fs-14"> Enter Your Phone Number </span>
                  </label>
                </div>
                @if (verifyForm.controls['doctor_mobile'].touched && verifyForm.controls['doctor_mobile'].invalid) {
                  <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                    >
                    Please Enter Valid Phone Number.
                  </p>
                }
                <!-- <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                *ngIf="verifyForm.controls['doctor_mobile'].touched && verifyForm.controls['doctor_mobile'].invalid && verifyForm.controls['doctor_mobile'].dirty">
                Please enter valid password (should be greater than 10 characters).
              </p> -->
            </div>
            <button [disabled]="( verifyForm.controls['doctor_mobile'].invalid)" class="btn btn-secondary mb-3 w-100 fw-600" type="submit">Get Verification Code</button>
          </div>
        </form>
      }
      @if (selectedStep === step.VERIFY_OTP) {
        <div class="mb-4">
          <h2 class="fs-36 fw-600 m-0 mb-3">
            Verify Your Phone <br> Number
          </h2>
          <p class="fs-16 fw-400 text-secondary m-0">
            We’ve sent a 6-digit verification code to <b>(XXX) XXX {{last4Number}}</b>. Please enter the code below to verify your phone number.
          </p>
        </div>
        <div class=" form-group mt-4 mb-3">
          <p class="fs-14 fw-500 text-secondary">Enter Verification Code</p>
          <form [formGroup]="otpForm" action="" (submit)="verifyOtp()">
            <div class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between">
              @for (item of otpValueGroup; track item; let index = $index) {
                <input id={{item}} (input)="onInput($event , index)"
                  (keydown.space)="$event.preventDefault()" (keydown.tab)="$event.preventDefault()"
                  (keydown.backspace)="onDelete($event , index)" formControlName="{{item}}"
                  type="text" maxlength="1"
                  placeholder="-" (paste)="onPasteHandler($safeNavigationMigration($event.clipboardData?.getData('text/plain')))"/>
              }
            </div>
            @if (countdown > 0) {
              <div class="py-3 fs-14 fw-500">Didn’t receive the code? {{ formatTime(countdown) }} seconds</div>
            }
            @if (countdown <= 0) {
              <div class="mb-4 ">Didn’t receive the code? <a class="color-blue cursor" (click)="renewOtp()">Resend Code</a></div>
            }
            <button class="btn btn-secondary w-100 fw-600" type="submit">Verify Phone Number</button>
            <button (click)="selectedStep = step.MOBILE_NUMBER" class="btn btn-default w-100 fw-600 mt-2" type="submit">Change Phone Number</button>
          </form>
        </div>
        <!-- <a (click)="selectedStep = step.MOBILE_NUMBER" class="text-line cursor">Change mobile number</a> -->
      }
    </div>
    <div class="footer bottom-10 position-absolute"> © FinanceMutual<sup>TM</sup> {{_shared.today | date:"yyyy"}}</div>
  </div>
</div>
</div>